import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import moment from 'moment'
import { BasicSelect,ModelSelect} from 'vue-search-select';
import download from 'downloadjs';
import DatePicker from 'vue2-datepicker'
import Paginate from 'vuejs-paginate'
import { PDFDocument } from 'pdf-lib';

export default {
  name: 'AWBPendingVerification',
  components: {
    BasicSelect,
    ModelSelect,
    VueElementLoading,
    download,
    DatePicker,
    Paginate,
  },
  props: [],
  data() {
    return {
      AWBnumber:'',
      AWBnumberparent:'',
      VFromDate:'',
      FromDate: moment().subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss'),
      todate: moment().format('YYYY-MM-DD HH:mm:ss'),
      vtodate:'',
      getAWBPendingCount:'',
      //getAWBCompletedCount:'',
      totalAWBRows: 0,
      pageCount:0,
      pageNo: 1,
      totalrecoreds:0,
      hideFilter:0,
      status:'',
      currentTab: 'pending',
      tabs: [{
					key: 'pending',
					value: 'Pending',
          count: 0
				},
				{
					key: 'completed',
					value: 'Completed',
          //count: 0
				}
			],
      FMBranch:'',
      FMBranchData:[],
      awbLoading:false,
      Branchloading:'',
      todaysDate:new Date(),
      currentHubId:'',
      AWBResponse:[]
    }
  },
  computed: {
    currentTabComponent: function() {
      this.componentKey += 1
      return this.currentTab.toLowerCase()
    }
  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY');
    }
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes             = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext         = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail        = JSON.parse(plaintext);
    this.useremail        = userdetail[0].email;
    this.currentHubId     = userdetail[0].HubId[0];

    this.getFMBranchData();
    this.getAWBDetails();
  },
  methods: {

    jsonToCSV(filename, data, csvfield, dateFilder = [], skipFilter = []) {
       var csvData = ''
       //Header
       if (this.title != null) {
         csvData += this.parseExtraData(this.title, '${data}\r\n')
       }
       //Fields
       for (let key in data[0]) {
         if (skipFilter.indexOf(key) == -1)
           csvData += csvfield[key] + ','
       }
       csvData = csvData.slice(0, csvData.length - 1)
       csvData += '\r\n'
       //Data
       data.map(function(item) {
         for (let key in item) {
           if (skipFilter.indexOf(key) == -1) {
             var escapedCSV = item[key] + '' // cast Numbers to string
             if (escapedCSV.match(/[,"\n]/)) {
               escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"'
             }
             if (escapedCSV == 'null')
               csvData += ',';
             else {
               if (dateFilder.indexOf(key) != -1)
                 csvData += moment(escapedCSV).format('DD-MM-YYYY HH:mm:ss') + ','
               else
                 csvData += escapedCSV + ','
             }
           }
         }
         csvData = csvData.slice(0, csvData.length - 1)
         csvData += '\r\n'
       })
       //Footer
       if (this.footer != null) {
         csvData += this.parseExtraData(this.footer, '${data}\r\n')
       }
       filename += moment().format('DD-MM-YYYY') + '.csv';
       return this.export(csvData, filename, "application/csv");
       return csvData
     },

     export (data, filename, mime) {
       let blob = this.base64ToBlob(data, mime)
       download(blob, filename, mime)
       this.$alertify.success("Successful")
     },

     base64ToBlob(data, mime) {
       let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
       let bstr = atob(base64)
       let n = bstr.length
       let u8arr = new Uint8ClampedArray(n)
       while (n--) {
         u8arr[n] = bstr.charCodeAt(n)
       }
       return new Blob([u8arr], {
         type: mime
       })
     },
     preventSpecialChar(e){
 			if (e.which < 48 ||
 	    (e.which > 57 && e.which < 65) ||
 	    (e.which > 90 && e.which < 97 && e.which !== 95) ||
 	    e.which > 122) {
 	    e.preventDefault();
 			}
 		},

     exportAWB() {
       this.awbLoading = true;
       let AWBDataFileds =
       'awbNo=' + (this.AWBnumber ? this.AWBnumber : this.AWBnumberparent ? this.AWBnumberparent : '') +
       '&fromDate=' + (this.FromDate ? moment(this.FromDate).format('YYYY-MM-DD') : '') +
       '&toDate=' + (this.todate ? moment(this.todate).format('YYYY-MM-DD') : '') +
       '&vfromDate=' + (this.VFromDate ? moment(this.VFromDate).format('YYYY-MM-DD') : '') +
       '&vtoDate=' + (this.vtodate ? moment(this.vtodate).format('YYYY-MM-DD') : '') +
       '&FMbranchId=' + (this.FMBranch ? this.FMBranch : this.currentHubId) +
       '&status='+ (this.AWBnumberparent ? '' : this.currentTab) + 
       '&PageSize=' + this.totalAWBRows;

       let api = 'getAWBVerificationList?';
       if(this.AWBnumberparent){
         AWBDataFileds =
         'awbNo=' + this.AWBnumberparent + '&HubID=' + this.currentHubId;
         api = 'getAWBVerificationDetails?';
       }

       axios({
           method: 'GET',
           'url': apiUrl.api_url_hubops + api + AWBDataFileds,
           'headers': {
             'authorization': 'authkey xB84JJ89Hd25',
           }
         })
         .then(result => {
           if (result.data.ResultCode == 100) {

             this.csvFields = {
               'AWB':'AWB Number',
               'MPSCount': 'MPS Count',
               'InScanDate': 'Inscan Date',
               'PickupDate': 'Pickup Date',
               'OriginHubID': 'Origin Hub ID',
               'VerificationDate': 'Verification Date',
               'VerifiedPhysicalWeight' : 'Verified Physical Weight',
               'VerifiedVolumetricWeight' : 'Verified Volumetric Weight',
               'PhysicalWeight': 'Physical Weight',
               'VolumetricWeight': 'Volumetric Weight',
               'FinalDestinationID': 'Final Destination ID',
               'Status': 'Status',
               'FMBranch': 'FM Branch',
               'DestinationName': 'Destination Name'
             };
             if(this.currentTab=='completed') this.csvFields.AWBVerificationMethod = 'AWB Verification Method';

             this.jsonToCSV('AWBVerificataionReport', result.data.ResponseData, this.csvFields);
           } else {
             this.$alertify.error(result.data.ReturnMessage)
           }
           this.awbLoading = false;
         }, error => {
           this.awbLoading = false;
           console.error(error)
         })
     },

     getAWBDetails(){
       this.awbLoading = true;
       let AWBDataFileds =
       'awbNo=' + (this.AWBnumber ? this.AWBnumber : this.AWBnumberparent ? this.AWBnumberparent : '') +
       '&fromDate=' + (this.FromDate ? moment(this.FromDate).format('YYYY-MM-DD') : '') +
       '&toDate=' + (this.todate ? moment(this.todate).format('YYYY-MM-DD') : '') +
       '&vfromDate=' + (this.VFromDate ? moment(this.VFromDate).format('YYYY-MM-DD') : '') +
       '&vtoDate=' + (this.vtodate ? moment(this.vtodate).format('YYYY-MM-DD') : '') +
       '&FMbranchId=' + (this.FMBranch ? this.FMBranch : this.currentHubId) +
       '&status='+ (this.AWBnumberparent ? '' : this.currentTab) +
       '&PageNumber=' + this.pageNo +
       '&PageSize=' + 50;

       this.AWBResponse = [];
       this.totalAWBRows = 0;

       let api = 'getAWBVerificationList?';
       if(this.AWBnumberparent){
         AWBDataFileds = 'awbNo=' + this.AWBnumberparent + '&HubID=' + this.currentHubId;
         api = 'getAWBVerificationDetails?';
       }

       axios({
           method: 'GET',
           'url': apiUrl.api_url_hubops + api + AWBDataFileds,
           'headers': {
             'authorization': 'authkey xB84JJ89Hd25',
           }
         })
         .then(result => {
           if (result.data.ResultCode == 100) {
             this.AWBResponse = result.data.ResponseData
             if(this.AWBnumberparent){
               this.currentTab = this.AWBResponse[0].Status ? this.AWBResponse[0].Status.toLowerCase():this.currentTab;
             }
             // else{
             //   this.tabs[1].count = result.data.Totalcount ? parseInt(result.data.Totalcount) : this.AWBResponse.length;
             // }
             this.totalAWBRows = result.data.Totalcount ? parseInt(result.data.Totalcount) : this.AWBResponse.length;
             if (this.totalAWBRows < 50) {
               this.pageCount = 1
             } else {
               this.pageCount = Math.ceil(this.totalAWBRows / 50);
             }
           }
           else{
             this.$alertify.error(result.data.ReturnMessage);
           }
           if(this.currentTab == 'pending' && !this.AWBnumberparent){
             this.tabs[0].count = result.data.PendingCount ? parseInt(result.data.PendingCount) : this.AWBResponse.length;
           }

           this.awbLoading = false;
         }, error => {
           this.awbLoading = false;
           console.error(error)
         })
     },

     //pagination data
     getPaginationData(pageNum) {
    	 this.pageNo = pageNum
    	 this.getAWBDetails()
     },

     //FMBranch API
     getFMBranchData(){
       axios({
           method: 'GET',
           'url': apiUrl.api_url_hubops + 'getFMBranch?currentHubId=' + this.currentHubId,
           'headers': {
             'authorization': 'authkey xB84JJ89Hd25',
           }
         })
         .then(result => {
           this.Branchloading = '';
           this.FMBranchData = result.data.ResultCode==100 ? result.data.ResponseData.map(i => ({ value:i.HubID, text:i.HubName +' ('+ i.HubID +')'})) : [];

         }, error => {
           console.error(error)
         })
     },

     // child AWB Function
     onSubmit: function(scope) {
       this.$validator.validateAll(scope)
         .then((result) => {
           if (!result) {
             console.log('errors exist', this.errors); return false;
           } else {
             this.AWBnumberparent = '';
             this.pageNo = 1;
             this.$refs.paginate.selected = 0;
             this.$validator.reset();
             this.getAWBDetails();
           }
         }).catch(() => {
           console.log(this.errors);
         });
     },

     //Parent AWB function
      AWBSubmit: function(validate) {
       this.$validator.validateAll('validate').then((result) => {

         if (!result) {
           return false;
         }else{
           this.pageNo = 1;
           this.AWBnumber = ''
           this.VFromDate = ''
           this.vtodate = ''
           this.FromDate = ''
           this.todate = ''
           this.FMBranch = ''
           this.$validator.reset();
           this.getAWBDetails();
         }
       }).catch(() => {
         console.log('errors exist', this.errors)
       });
     },
     /// Pending & completed tab function///
      secondFunction(tab){
        this.selectedHubArr= [];
        this.resetForm();
        if(tab.key == "pending"){
          this.FromDate = moment().subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss');
          this.todate = moment().format('YYYY-MM-DD HH:mm:ss');
          this.getAWBDetails();
        }
      },

      resetForm() {

        this.AWBnumber='',
        this.AWBnumberparent='',
        this.VFromDate='',
        this.FromDate='',
        this.todate='',
        this.vtodate='',
        this.getAWBPendingCount='',
        //this.getAWBCompletedCount='',
        this.totalAWBRows=0,
        this.pageNo= 1,
        this.totalrecoreds=0,
        this.FMBranch='',
        this.AWBResponse =[],
        this.$validator.reset();
      },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/AWBPendingVerification/AWBPendingVerification.component.js